export enum CountryName {
  UNITED_ARAB_EMIRATES = 'United Arab Emirates',
  KINGDOM_OF_SAUDI_ARABIA = 'KSA',
  UNITED_KINGDOM = 'United Kingdom',
  QATAR = 'Qatar',
  KUWAIT = 'Kuwait',
  JORDAN = 'Jordan',
  ROMANIA = 'Romania'
}
